import { createSlice } from "@reduxjs/toolkit";
import { getAttendance } from "../reduxApi/AttendanceReduxApi";

const timesheetSlice = createSlice({
    name: 'timesheet',
    initialState: {
        status: 'idel',
        timesheet: [],
    },
    reducers: {
        deleteAttendanceAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.timesheet.findIndex((item) => item.timeSheet.ROWID === id);
                if (index !== -1) {
                    state.timesheet.splice(index, 1);
                }
            });
        },
        updateAttendanceAction: (state, action) => {
            console.log("action", action.payload)
            const index = state.timesheet.findIndex((item) => item.timeSheet.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.timesheet.splice(index, 1, { timeSheet: action.payload })
            }
        },
        addAttendanceAction: (state, action) => {
            console.log("Adding Attendance:", action.payload);
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID
            state.timesheet.unshift({timeSheet:temp});
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getAttendance.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getAttendance.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing Attendance Data", action.payload)
                state.timesheet = action.payload.data.response
;
            })
    }
})
export const { deleteAttendanceAction, updateAttendanceAction, addAttendanceAction } = timesheetSlice.actions
export default timesheetSlice.reducer